import React from 'react';
import {
  Modal, Box, Button, FormControl, FormLabel, RadioGroup,
  FormControlLabel, Radio
} from '@mui/material';
import CustomMonthDatePicker from '../CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js';
import CloseIcon from '@mui/icons-material/Close';

/**
 * ReportDateModal - Date selection modal for VAT and Advance reports
 */
export default function ReportDateModal({
  open,
  onClose,
  direction = 'ltr',
  isDateRange,
  setIsDateRange,
  date,
  setDate,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onDownload,
  reportType, // 'WithholdingTax' or 'VAT'
  t,
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="report-date-modal-title"
      aria-describedby="report-date-modal-description"
      sx={{ zIndex: 1300 }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: 400,
          maxWidth: 600,
          width: '90%',
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: 24,
          padding: 4,
          outline: 'none',
        }}
        className={`modal-container ${direction}`}
      >
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <h2 id="report-date-modal-title" style={{ margin: 0, fontSize: '24px', fontWeight: 600 }}>
            {reportType === 'WithholdingTax' ? t('AdvancesReport') : t('VATReport')}
          </h2>
          <Box
            onClick={onClose}
            sx={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: '50%',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            <CloseIcon />
          </Box>
        </Box>

        {/* Date Selection */}
        <FormControl sx={{ mb: 3, width: '100%' }}>
          <FormLabel>{t('SelectDateOption')}</FormLabel>
          <RadioGroup
            row
            value={isDateRange ? 'dateRange' : 'singleDate'}
            onChange={(e) => setIsDateRange(e.target.value === 'dateRange')}
          >
            <FormControlLabel
              value="singleDate"
              control={<Radio />}
              label={t('SingleDate')}
            />
            <FormControlLabel
              value="dateRange"
              control={<Radio />}
              label={t('DateRange')}
            />
          </RadioGroup>
        </FormControl>

        {/* Date Pickers */}
        <Box sx={{ mb: 3 }}>
          {isDateRange ? (
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Box sx={{ flex: 1, minWidth: 180 }}>
                <CustomMonthDatePicker
                  label={t('StartDate')}
                  date={startDate}
                  onDateChange={setStartDate}
                  height="55px"
                />
              </Box>
              <Box sx={{ flex: 1, minWidth: 180 }}>
                <CustomMonthDatePicker
                  label={t('EndDate')}
                  date={endDate}
                  onDateChange={setEndDate}
                  height="55px"
                />
              </Box>
            </Box>
          ) : (
            <Box sx={{ minWidth: 180 }}>
              <CustomMonthDatePicker
                label={t('date')}
                date={date}
                onDateChange={setDate}
                height="55px"
              />
            </Box>
          )}
        </Box>

        {/* Action Buttons */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              minWidth: 100,
              borderRadius: 1,
              borderColor: '#ccc',
              color: '#666',
              '&:hover': {
                borderColor: '#999',
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            {t('Cancel')}
          </Button>
          <Button
            variant="contained"
            onClick={onDownload}
            sx={{
              minWidth: 120,
              borderRadius: 1,
              backgroundColor: '#304FFF',
              '&:hover': {
                backgroundColor: '#1565c0',
              },
            }}
          >
            {t('Download')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

